module.exports = __webpack_public_path__ + "img/business-3.da3b10cf.png";